import React, {useState} from 'react'

import '../assets/dist/css/adminlte.min.css'

import SidebarMenu from "../ThemeComponents/SidebarMenu";
import NavMenu from "../ThemeComponents/NavMenu";
import ContainerFluid from "../ThemeComponents/grid/ContainerFluid";
import Row from "../ThemeComponents/grid/Row";
import Col from "../ThemeComponents/grid/Col";

const BlankPageTemplate = ({title, children}) => {

    const [sidebarOpen, setSidebarOpen] = useState(true)

    const onSidebarCollapseClick = () => {
        setSidebarOpen(!sidebarOpen)
    }

    return (
        <div className={`layout-fixed sidebar-expand-lg bg-body-tertiary app-loaded sidebar-${sidebarOpen ? 'open' : 'collapse'}`}
        >
            <div className="app-wrapper">
                <NavMenu onSidebarClick={onSidebarCollapseClick} />
                <SidebarMenu />
                <main className="app-main">
                    <div className="app-content-header">
                        <ContainerFluid>
                            <Row>
                                <Col cols="col-sm-6">
                                    <h3 className="mb-0">{title}</h3>
                                </Col>
                            </Row>
                        </ContainerFluid>
                    </div>
                    <div className="app-content">{children}</div>
                </main>
            </div>
        </div>
    )
}

export default BlankPageTemplate